// == Unichat Extension ==
// Busca a logo/logo interna/favicon customizados pelo admin (endpoint público,
// usado tanto na tela de login (bundle v3app) quanto no dashboard autenticado
// (bundle dashboard). Usa o axios importado diretamente em vez de
// window.axios, pois o bundle v3app (tela de login) nunca define esse
// global — só o entrypoint do dashboard o faz.
import { ref } from 'vue';
import axios from 'axios';

const DEFAULT_LOGO = '/unichat-icon.png';

const logoUrl = ref(DEFAULT_LOGO);
const logoInternalUrl = ref('');
const faviconUrl = ref('');
let inflightFetch = null;

const applyFavicon = url => {
  if (!url) return;
  document
    .querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
    .forEach(link => {
      link.href = url;
    });
};

export function useBranding() {
  const fetchBranding = () => {
    // Evita disparar a mesma requisição em paralelo, mas nunca trava em cache
    // permanente — a logo pode ter sido alterada/removida pelo admin desde a
    // última busca, então cada chamada (ex.: ao entrar na tela de login)
    // deve refletir o estado atual do servidor.
    if (inflightFetch) return inflightFetch;
    inflightFetch = axios
      .get('/api/v1/unichat/public/branding')
      .then(({ data }) => {
        logoUrl.value = data.logo_url || DEFAULT_LOGO;
        logoInternalUrl.value = data.logo_internal_url || '';
        faviconUrl.value = data.favicon_url || '';
        applyFavicon(data.favicon_url);
      })
      .catch(() => {
        // Mantém os defaults em caso de erro (ex.: rota ainda não disponível)
      })
      .finally(() => {
        inflightFetch = null;
      });
    return inflightFetch;
  };

  return {
    logoUrl,
    logoInternalUrl,
    faviconUrl,
    fetchBranding,
  };
}
